import { render, staticRenderFns } from "./campProductPage.vue?vue&type=template&id=a4a0f2c2&scoped=true&"
import script from "./campProductPage.vue?vue&type=script&lang=js&"
export * from "./campProductPage.vue?vue&type=script&lang=js&"
import style0 from "./campProductPage.vue?vue&type=style&index=0&id=a4a0f2c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a0f2c2",
  null
  
)

export default component.exports